import { ActionContext } from 'vuex';
import { EventBus, HttpStore } from '@integrai/ui';
import StateType from './state.type';

export default {
  async getStocks(context: ActionContext<StateType, {}>, filters: any): Promise<void> {
    const { commit } = context || {};

    commit('toggleLoading', true);

    try {
      const response: any = await HttpStore.post('product-stocks/filter', filters);

      commit('setStocks', response.stocks);
      commit('setTotal', response.total);
      commit('toggleLoading', false);
    } catch {
      commit('toggleLoading', false);
    }
  },
  async searchProduct(context: ActionContext<StateType, {}>, query: string): Promise<void> {
    const { commit } = context || {};

    commit('toggleLoadingProduct', true);

    try {
      const response: any = await HttpStore.post('products/filter', {
        page: 1,
        limit: 1,
        query,
      });

      const [product] = response.products || [];

      if (!product) {
        throw new Error('Produto não encontrado');
      }

      commit('setProductInfo', {
        id: product.id,
        name: product.name,
        sku: product.sku,
        gtin: product.gtin,
        photo: product.photos[0],
      });
      commit('toggleLoadingProduct', false);
    } catch {
      commit('toggleLoadingProduct', false);

      EventBus.$emit('toast', {
        type: 'is-danger',
        message: 'Produto não encontrado',
      });
    }
  },
  async saveProductStock(context: ActionContext<StateType, {}>, form: string): Promise<void> {
    const { commit } = context || {};

    commit('toggleLoadingModal', true);

    try {
      await HttpStore.post('product-stocks', form);

      commit('setProductInfo', null);

      EventBus.$emit('toast', {
        type: 'is-success',
        message: 'Movimento lançado com sucesso',
      });
      commit('toggleLoadingModal', false);
    } catch {
      commit('toggleLoadingModal', false);
    }
  },
};
